import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-alert',
  styleUrl: 'signet-alert.scss',
  shadow: true,
})
export class SignetAlert {
  /**
   *  Used to specify the severity level of the alert, determining its appearance. It can have one of four values: 'success', 'error', 'warning', or 'info'.
   */
  @Prop() severity: 'success' | 'error' | 'warning' | 'info' = 'success';

  render() {
    const classes = {
      'signet-alert': true,
      [this.severity]: true,
    };
    return (
      <div class={classes}>
        <signet-icon
          icon={
            this.severity === 'success'
              ? 'check_circle'
              : this.severity === 'warning'
              ? 'warning_amber'
              : this.severity === 'info'
              ? 'info_outline'
              : this.severity === 'error'
              ? 'do_not_disturb_on'
              : ''
          }
          class="icon"
        ></signet-icon>
        <span>
          <slot></slot>
        </span>
      </div>
    );
  }
}
